<aside class="sidebar" [class.collapsed]="isCollapsed$ | async" *ngIf="isAuthenticated$ | async">
  <div class="sidebar-header">
    <div class="logo-container" (click)="navigateToSite()" title="Volver al Sitio Público">
      <img src="https://cdaraucania.sfo2.cdn.digitaloceanspaces.com/01.resources/02.cdaraucania/01.img/da-logo.png" 
           alt="Desarrolla Araucanía" 
           class="logo">
    </div>
    <button class="toggle-btn" (click)="toggleSidebar()" title="Alternar Menú">
      <span class="toggle-icon"></span>
    </button>
  </div>

  <div class="sidebar-content">
    <div class="nav-groups">
      <div class="nav-group" *ngFor="let group of filteredGroups$ | async" [class.collapsed]="isGroupCollapsed(group.title)">
        <h3 class="group-title" 
            *ngIf="group.title" 
            (click)="toggleGroup(group.title)"
            [title]="isGroupCollapsed(group.title) ? 'Expandir' : 'Colapsar'">
          <span>{{ group.title }}</span>
          <mat-icon class="collapse-icon" [class.rotated]="isGroupCollapsed(group.title)">keyboard_arrow_down</mat-icon>
        </h3>
        <ul class="nav-list" *ngIf="!isGroupCollapsed(group.title)">
          <li class="nav-item" *ngFor="let item of group.items">
            <a [routerLink]="item.route"
               [queryParams]="item.queryParams || null"
               class="nav-link"
               [class.active]="isActive(item.route, item.queryParams)"
               [title]="item.label">
              <span class="nav-icon">
                <mat-icon>{{ item.icon }}</mat-icon>
                <span class="badge dot-badge" *ngIf="item.route === '/admin/inbox' && (unreadCount$ | async) as count" [class.has-count]="count > 0"></span>
              </span>
              <span class="nav-label-group">
                <span class="nav-subtitle" *ngIf="item.subtitle">{{ item.subtitle }}</span>
                <span class="nav-label">{{ item.label }}</span>
              </span>
              <span class="badge count-badge" *ngIf="item.route === '/admin/inbox' && (unreadCount$ | async) as count" [class.has-count]="count > 0">{{ count }}</span>
            </a>
            <ul class="nav-list nav-list-nested" *ngIf="item.children?.length">
              <li class="nav-item" *ngFor="let child of item.children">
                <a [routerLink]="child.route"
                   [queryParams]="child.queryParams || null"
                   class="nav-link nav-link-nested"
                   [class.active]="isActive(child.route, child.queryParams)"
                   [title]="child.label">
                  <span class="nav-icon"><mat-icon>{{ child.icon }}</mat-icon></span>
                  <span class="nav-label">{{ child.label }}</span>
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="sidebar-footer" *ngIf="userProfile$ | async as profile">
    <div class="user-info">
      <div class="user-avatar" title="Ver Perfil">
        {{ getUserInitials(profile) }}
      </div>
      <div class="user-details" [class.hidden]="isCollapsed$ | async">
        <span class="user-name">{{ profile.displayName }}</span>
        <span class="user-email">{{ profile.mail }}</span>
      </div>
    </div>
    <button class="logout-btn" (click)="logout()" title="Cerrar Sesión">
      <mat-icon class="logout-icon">logout</mat-icon>
    </button>
  </div>
</aside>
